import {
  ColumnRowGroupChangedEvent,
  FirstDataRenderedEvent,
  RowGroupOpenedEvent,
} from "@ag-grid-community/core";
import { useCallback } from "react";
import { DataTableProps } from "shared/components/table/data/DataTableProps";
import { GenericTableAgGridReactProps } from "shared/components/table/data/DataTableTypes";
import {
  COLUMN_ID_ACTIONS,
  COLUMN_ID_AUTO_COLUMN,
} from "shared/components/table/data/internal/DataTableConstants";

export const useDataTableAutoSizeColumnsAgProps = ({
  fillWidth,
}: DataTableProps): GenericTableAgGridReactProps => {
  const isEnabled = !fillWidth;

  const onFirstDataRendered = useCallback(
    (event: FirstDataRenderedEvent) => {
      if (isEnabled) {
        event.api.autoSizeAllColumns(false);
      } else {
        event.api.autoSizeColumns([COLUMN_ID_ACTIONS], true);
      }
    },

    [isEnabled],
  );

  const onColumnRowGroupChanged = useCallback(
    (event: ColumnRowGroupChangedEvent) => {
      if (isEnabled) {
        setTimeout(() => {
          event.api.autoSizeColumns([COLUMN_ID_AUTO_COLUMN]);
        });
      }
    },
    [isEnabled],
  );

  const onRowGroupOpened = useCallback(
    (event: RowGroupOpenedEvent) => {
      if (isEnabled) {
        setTimeout(() => {
          const firstColumn = event.api.getAllDisplayedColumns()[0];
          event.api.autoSizeColumns([firstColumn]);
        });
      }
    },
    [isEnabled],
  );

  return {
    onFirstDataRendered,
    onColumnRowGroupChanged,
    onRowGroupOpened,
  };
};
